import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Md2AccountPlus } from "react-icons-ng/md2";

import {
  IonHeader,
  IonToolbar,
  IonRouterLink,
  IonButtons,
  IonButton,
  IonModal,
  IonSegment,
  IonSegmentButton,
  IonLabel,
} from "@ionic/react";
import { Md2ChevronLeft } from "react-icons-ng/md2";
import InviteUser from "./inviteUser";
import { useLeague } from "context/leagueContext";

const TournamentHeader = ({ selectedTab, setTabHandler }) => {
  const { t } = useTranslation();
  const {
    state: { leagueInfo },
  } = useLeague();
  const modal = useRef(null);
  const isJoinable =
    leagueInfo?.gameType == 1
      ? new Date(leagueInfo?.deadline?.seconds * 1000) > new Date()
      : true;

  return (
    <>
      <IonModal
        ref={modal}
        trigger="open-modal"
        initialBreakpoint={0.25}
        breakpoints={[0, 0.25, 0.5, 0.75]}
      >
        <InviteUser />
      </IonModal>

      <IonHeader mode="ios" className="ion-no-border">
        <IonToolbar className="gradientToolbarPrimary" mode="ios">
          <IonButtons slot="start">
            <IonRouterLink
              routerLink="/tabs/tournaments"
              routerDirection="back"
              slot="start"
              className="self-middle items-center justify-center flex"
            >
              <Md2ChevronLeft className="w-8 h-8 shrink-0 text-white" />
            </IonRouterLink>
          </IonButtons>

          <IonButtons slot="end">
            {isJoinable && (
              <IonButton
                detail="false"
                id="open-modal"
                expand="block"
                className="customButton noOpacity"
              >
                <Md2AccountPlus className="h-6 w-6 shrink-0 text-white" />
              </IonButton>
            )}
          </IonButtons>
          <IonSegment
            mode="ios"
            value={selectedTab}
            onIonChange={setTabHandler}
          >
            <IonSegmentButton value={0}>
              <IonLabel>{t("tournament.tabs.rounds")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value={1}>
              <IonLabel>{t("tournament.tabs.top_list")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value={2}>
              <IonLabel>{t("tournament.tabs.info")}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>
    </>
  );
};

export default TournamentHeader;
